import { Component, OnInit, Inject } from "@angular/core";
import { WorkGroupsDataService } from "../core/workgroups.dataservice";
import { PersonDataService } from "../core/persons.dataservice";
import { WorkgroupPersonDataService } from "../core/workgrouppersons.dataservice";
import { WorkSchedulesDataService } from "../core/workschedules.dataservice";
import { WorkplaceDataService } from "../core/workplaces.dataservice";
import { WorkScheduleMustersDataService } from "../core/workschedulemustersdataservice";
import { StateService } from "@uirouter/angular";
import dataCore = require("../core/datacore");
import { CrewPermissionsService } from "../core/crew-permissions.service";
 
@Component({
    selector: "crew-work-schedule-musters",
    template: require('./work-schedule-musters.component.html'),
    styles: [require('./work-schedule-musters.component.css')]
})
export class WorkScheduleMustersComponent implements OnInit {

    isPermissionWriteOrAdmin: boolean;

    workPlaces: Nema.Crew.Model.Workplace[];
    workSchedules: Nema.Crew.Model.WorkSchedule[];
    workGroups: Nema.Crew.Model.WorkGroup[];
    persons: Nema.Crew.Model.Person[];

    constructor(
        @Inject(WorkGroupsDataService.Id) private workGroupsDataService: WorkGroupsDataService,
        @Inject(PersonDataService.Id) private personService: PersonDataService,
        @Inject(WorkgroupPersonDataService.Id) private workgroupPersonService: WorkgroupPersonDataService,
        @Inject(WorkSchedulesDataService.Id) private workSchedulesDateService: WorkSchedulesDataService,
        @Inject(WorkplaceDataService.Id) private workplaceDateService: WorkplaceDataService,
        @Inject("$log") private $log: ng.ILogService,
        private workScheduleMusterDataService: WorkScheduleMustersDataService,
        private stateService: StateService,
        private crewPermissionsService: CrewPermissionsService) { }

    public processing: boolean = false;

    ngOnInit(): void {
        this.crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);

        this.workGroupsDataService
            .getAll()
            .then(res => this.workGroups = res.filter(w => w.Active));

        this.personService
            .getAll()
            .then(res => this.persons = res.filter(p => p.Active));

        this.workgroupPersonService.getAll();

        this.workSchedulesDateService
            .getAll()
            .then(res => this.workSchedules = res.filter(w => w.Active));

        this.workplaceDateService
            .getAll()
            .then(res => this.workPlaces = res.filter(w => w.Active));

        this.startDate = dataCore.getToday();

        var now = dataCore.getToday();
        this.endDate = new Date(now.setMonth(now.getMonth() + 3));
    }

    public selectedPersons: Nema.Crew.Model.Person[] = [];
    public workSheduleTemplateId: number;
    public workPlaceId: number;
    public startDate: Date;
    public endDate: Date;

    workScheduleResonce: Nema.Crew.Model.Activity[];

    musterShip(): void {

        this.processing = true; 

        this.workScheduleMusterDataService.musterShip
            ({
                WorkPlaceId: this.workPlaceId,
                WorkSheduleTemplateId: this.workSheduleTemplateId,
                PersonIds: this.selectedPersons.map(person => person.Id),
                StartDate: dataCore.subtractTimezoneOffset(this.startDate),
                EndDate: dataCore.subtractTimezoneOffset(this.endDate)
            })
            .then(response =>
            {
                this.workScheduleResonce = response;
                this.processing = false;
                this.stateService.go("app.activities.overview.with-params", { workplaceId: this.workPlaceId, workgroupId: -1, year: this.startDate.getFullYear(), month: this.startDate.getMonth() + 1 });
            })
            .catch(err => {
                this.$log.error(err);
                this.processing = false;
            });
    }

    public entityDisplayName = "Scheduling";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/work-schedule-musters.component.ts